import {FC, useEffect, useState} from "react";
import {PresentationItemFormProps} from "./types";
import {Form, InputNumber, Row, UploadFile} from "antd";
import Uploader from "../../../uploader/Uploader";
import * as BUCKETS from "../../../../enums/buckets";
import TextEditor from "../../../text-editor/TextEditor";
import "./style.less"
import {getImageLink} from "../../../../helpers/mainHelpers";

const PresentationItemForm: FC<PresentationItemFormProps> = (props) => {
  const {presentationController} = props
  const {form, submitFormHandler, selectedPresentationItem} = presentationController

  const [image, setImage] = useState<UploadFile[]>([])
  const [description, setDescription] = useState("")

  console.log("description", description)

  useEffect(() => {
    if (selectedPresentationItem) {
      const imageData = {
        uid: selectedPresentationItem.imageId,
        name: "image",
        url: getImageLink({imageId: selectedPresentationItem.imageId, bucketId: BUCKETS.MAIN}),
        response: {$id: selectedPresentationItem.imageId}
      }
      setImage([imageData])
      // setDescription(selectedPresentationItem.description)
      form.setFieldsValue(selectedPresentationItem)

    }
  }, [selectedPresentationItem])

  const submitButtonHandler = (props: {
    order: number;
  }) => {
    if (image?.length >= 1) {
      const {order} = props
      const data = {
        order,
        imageId: image[0].response.$id || "",
        description,
      }
      submitFormHandler(data)
    }
  }

  return (
    <Form form={form} layout="vertical" className="presentationItem_form" onFinish={submitButtonHandler}>
      <Row>
        <Form.Item label="Зображення">
          <Uploader maxCount={1} bucketId={BUCKETS.MAIN} files={image} setFiles={setImage}/>
        </Form.Item>
      </Row>
      <Row gutter={[16, 0]}>
        <Form.Item name="order" label="Номер по порядку" rules={[{required: true}]}>
          <InputNumber className="order_field" placeholder="Введіть номер по порядку"/>
        </Form.Item>
      </Row>
      <Row gutter={[16, 0]}>
        <Form.Item name="description" label="Текст">
          <TextEditor value={description} setValue={setDescription}/>
        </Form.Item>
      </Row>
    </Form>
  )
}

export default PresentationItemForm